var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3888 11.1362L11.12 10.405L8.53625 7.805V4.53875H7.56125V8.195L10.3888 11.1362ZM8 14.5C7.11167 14.5 6.27208 14.3294 5.48125 13.9881C4.69042 13.6469 3.99979 13.181 3.40937 12.5906C2.81896 12.0002 2.35312 11.3096 2.01187 10.5187C1.67063 9.72792 1.5 8.88833 1.5 8C1.5 7.11167 1.67063 6.27208 2.01187 5.48125C2.35312 4.69042 2.81896 3.99979 3.40937 3.40937C3.99979 2.81896 4.69042 2.35312 5.48125 2.01187C6.27208 1.67063 7.11167 1.5 8 1.5C8.88833 1.5 9.72792 1.67063 10.5187 2.01187C11.3096 2.35312 12.0002 2.81896 12.5906 3.40937C13.181 3.99979 13.6469 4.69042 13.9881 5.48125C14.3294 6.27208 14.5 7.11167 14.5 8C14.5 8.88833 14.3294 9.72792 13.9881 10.5187C13.6469 11.3096 13.181 12.0002 12.5906 12.5906C12.0002 13.181 11.3096 13.6469 10.5187 13.9881C9.72792 14.3294 8.88833 14.5 8 14.5ZM8 13.525C9.51667 13.525 10.8167 12.9833 11.9 11.9C12.9833 10.8167 13.525 9.51667 13.525 8C13.525 6.48333 12.9833 5.18333 11.9 4.1C10.8167 3.01667 9.51667 2.475 8 2.475C6.48333 2.475 5.18333 3.01667 4.1 4.1C3.01667 5.18333 2.475 6.48333 2.475 8C2.475 9.51667 3.01667 10.8167 4.1 11.9C5.18333 12.9833 6.48333 13.525 8 13.525Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.3b990e6a80bb69d6466ec73fcba60952.svg";
export { ForwardRef as ReactComponent };